export const applicationPropertiesSnippet =
`spring:
  datasource: 
    url: jdbc:postgresql://dbhost:5432/dbname
    username: dbuser
    password: topsecret
nca.ds.core:
  config-storage-json:
    resource-location: file:config/ds-config.json
`

export const databaseConfigurationSnippet =
`spring:
  datasource: 
    url: jdbc:postgresql://dbhost:5432/dbname
    username: dbuser
    password: topsecret
 `

export const inboundHttpsConnectionSnippet =
`server:
  ssl:
    bundle: webserver
spring:
  ssl:
    bundle:
      jks:
        webserver:
          keystore:
            type: PKCS12
            location: file:config/certs/keystore.p12
            password: topsecret
`

export const inboundHttpsConnectionUsingPemSnippet =
`server:
  ssl:
    bundle: webserver
    client-auth: need
spring:
  ssl:
    bundle:
      pem:
        webserver:
          keystore:
            certificate: file:config/certs/webserver.crt
            private-key: file:config/certs/webserver.key
          truststore:
            certificate: file:config/certs/webserver-ca.crt
`


export const dsConfigLocationSnippet =
`nca.ds.core:
  config-storage-json:
    resource-location: file:config/ds-config.json
`

export const securingCredentialsSnippet =
`spring:
  config:
    import: configtree:config/credentials/
  datasource:
    url: jdbc:postgresql://dbhost:5432/dbname
    username: \${db-credential-secret.username}
    password: \${db-credential-secret.password}
`

export const loggingSnippet=
`logging:
  config: classpath:logback-json.xml
`
export const outboundMtlsConnectionSnippet =
`spring:
  ssl:
    bundle:
      jks:
        ssl-client:
          keystore:
            type: PKCS12
            location: file:config/certs/ssl-client-keystore.p12
            password: topsecret
          truststore:
            type: PKCS12
            location: file:config/certs/ssl-client-truststore.p12
            password: topsecret
nca.ds.core:
  httpclient:
    ssl-bundle: ssl-client          
`

export const outboundMtlsConnectionPemSnippet =
`spring:
  ssl:
    bundle:
      pem:
        ssl-client:
          keystore:
            certificate: file:config/certs/ssl-client.crt
            private-key: file:config/certs/ssl-client.key
          truststore:
            certificate: file:config/certs/ssl-client-ca.crt       
nca.ds.core:
  httpclient:
    ssl-bundle: ssl-client          
`
export const deviceInfoDecryptionSnippet =
`nca.ds.core:
  device-info-decryption:
    keystore-type: PKCS12
    keystore-location: file:config/certs/did-keystore.p12
    keystore-password: topsecret
`
export const serverSignedContentSnippet =
`nca.ds.core:
  sdk-server-signed-content-validator:
    certificate-revocation-enabled: false
    ssl-bundle: ssl-client          
`
